<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1 font-weight-bold">{{ titreMotif }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-textarea
              name="input-7-1"
              filled
              auto-grow
              counter
              :maxlength="4000"
              v-model="motif"
            ></v-textarea>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <div class="text-center">
            <v-btn class="mx-2 primary" @click="continuerMotif">
              <v-icon left>save</v-icon>
              Continuer
            </v-btn>
            <v-btn class="mx-2 normal" @click="annulerMotif">
              <v-icon left>mdi-close</v-icon>
              Annuler
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-col cols="12">
      <BaseBlock v-if="!loading.display" :title="titre">
        <ResumeCandidature
          v-if="candidature.id"
          :candidature="candidature"
          :voirTypeEtudiant="false"
        ></ResumeCandidature>

        <v-row cols="12" justify="center">
          <div class="text-center">
            <v-btn
              v-if="
                candidature.etatDemande.id == ETAT.TRAITEMENT_PEDAGOGIQUE.code
              "
              :loading="loadingBtn"
              title="Vous acceptez cette candidature pour cette formation"
              @click="saisieMotifAccepter"
              class="ma-2"
              color="primary"
              ><v-icon left>mdi-check-bold</v-icon>Accepter la
              candidature</v-btn
            >
            <ButtonConfirmation
              v-if="candidature.etatDemande.id == ETAT.REFUSEE.code"
              :inactif="loadingBtn"
              icone="mdi-step-backward"
              libelle="Revenir sur la décision"
              title="La candidature est replacée dans l'état 'en attente d'examen'"
              @ok="repentir"
            ></ButtonConfirmation>
            <v-btn
              v-if="
                candidature.etatDemande.id == ETAT.TRAITEMENT_PEDAGOGIQUE.code
              "
              class="ma-2"
              color="primary"
              title="Vous rejetez cette candidature pour cette formation"
              @click="saisieMotifRefus"
              :loading="loadingBtn"
            >
              <v-icon left>mdi-window-close</v-icon>Refuser la candidature
            </v-btn>
            <v-btn
              v-if="
                candidature.etatDemande.id == ETAT.TRAITEMENT_PEDAGOGIQUE.code
              "
              class="ma-2"
              color="primary"
              title="Le dossier est incomplet. Vous le retournez à l'étudiant"
              @click="saisieMotifRenvoyer"
              :loading="loadingBtn"
            >
              <v-icon left>mdi-account-arrow-left</v-icon>Autoriser la
              rectification
            </v-btn>
            <router-link
              :to="{
                name: 'listing-enseignant',
                params: { idFormation: candidature.formation.id },
              }"
            >
              <v-btn class="ma-2" color="primary">Retour</v-btn>
            </router-link>
          </div>
        </v-row>
      </BaseBlock>
    </v-col>
  </v-row>
</template>
<script>
import BaseBlock from "@/components/base/BaseBlock";
import ResumeCandidature from "@/components/ResumeCandidature";
import ButtonConfirmation from "@/components/ButtonConfirmation";
import ApiCandidatureRepository from "@/repositories/ApiCandidatureRepository";
import { EtatDemande } from "@/mixins/EtatDemande.js";
import { mapState } from "vuex";

export default {
  name: "DetailCandidatureEnseignant",
  props: ["idCandidature"],
  mixins: [EtatDemande],
  components: { BaseBlock, ResumeCandidature, ButtonConfirmation },
  data() {
    return {
      loadingBtn: false,
      candidature: {
        id: "",
        etudiant: {},
        formation: {},
        etatDemande: {},
        bacSerie: "",
      },
      dialog: false,
      motif: "",
      actionMotif: "",
    };
  },
  methods: {
    async getCandidature() {
      //await new Promise(r => setTimeout(r, 2000));
      try {
        const candidature = await ApiCandidatureRepository.getCandidature(
          this.idCandidature
        );
        this.candidature = candidature;
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      } finally {
        this.$store.commit("setEcranChargement", false);
      }
    },
    retourListing() {
      this.$router.push({
        name: "listing-enseignant",
        params: { idFormation: this.candidature.formation.id },
      });
    },
    async valider() {
      this.loadingBtn = true;
      try {
        await ApiCandidatureRepository.validerCandidatureEnseignant(
          this.idCandidature,
          this.motif
        );
        this.$toast.info(
          "La candidature a été acceptée. Une notification par mail a été adressée à l'étudiant."
        );
        this.retourListing();
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      } finally {
        this.loadingBtn = false;
      }
    },
    async repentir() {
      this.loadingBtn = true;
      try {
        await ApiCandidatureRepository.repentirCandidatureEnseignant(
          this.idCandidature
        );
        this.$toast.info("Vous pouvez à nouveau étudier cette candidature.");
        this.retourListing();
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      } finally {
        this.loadingBtn = false;
      }
    },
    async refuser() {
      this.loadingBtn = true;
      try {
        await ApiCandidatureRepository.refuserCandidatureEnseignant(
          this.idCandidature,
          this.motif
        );
        this.$toast.info(
          "La candidature a été refusée. Une notification par mail a été adressée à l'étudiant."
        );
        this.retourListing();
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      } finally {
        this.loadingBtn = false;
        this.motif = "";
      }
    },
    async renvoyer() {
      this.loadingBtn = true;
      try {
        await ApiCandidatureRepository.renvoyerCandidature(
          this.idCandidature,
          this.motif
        );
        this.$toast.info(
          "La candidature a été renvoyée à l'étudiant. Une notification par mail lui a été adressée."
        );
        this.retourListing();
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      } finally {
        this.loadingBtn = false;
        this.motif = "";
      }
    },
    saisieMotifAccepter() {
      this.actionMotif = "accepter";
      this.dialog = true;
    },
    saisieMotifRefus() {
      this.actionMotif = "refus";
      this.dialog = true;
    },
    saisieMotifRenvoyer() {
      this.actionMotif = "renvoyer";
      this.dialog = true;
    },
    continuerMotif() {
      this.dialog = false;
      if (this.motif === "" && this.actionMotif !== "accepter") {
        if (this.actionMotif === "renvoyer") {
          this.$toast.error(
            "Vous devez indiquer la cause du retour du dossier de candidature"
          );
        } else {
          this.$toast.error("Vous devez motiver votre décision");
        }
      } else {
        if (this.actionMotif === "accepter") {
          this.valider();
        } else if (this.actionMotif === "refus") {
          this.refuser();
        } else {
          this.renvoyer();
        }
      }
      this.actionMotif = "";
    },
    annulerMotif() {
      this.dialog = false;
      this.actionMotif = "";
      this.motif = "";
    },
  },
  computed: {
    ...mapState(["loading"]),
    titre() {
      if (this.candidature.id) {
        return `Candidature de ${this.candidature.etudiant.nom} ${this.candidature.etudiant.prenom} à la formation ${this.candidature.formation.libelle}`;
      } else {
        return "";
      }
    },
    titreMotif() {
      let titre;
      if (this.actionMotif === "accepter") {
        titre = "Commentaire optionnel associé à l'acceptation du dossier";
      } else if (this.actionMotif === "renvoyer") {
        titre = "Veuillez saisir la raison du retour du dossier";
      } else if (this.actionMotif === "refus") {
        titre = "Veuillez saisir la raison du refus du dossier";
      }
      return titre;
    },
  },
  async created() {
    this.$store.commit("setEcranChargement", true);
    this.getCandidature();
  },
};
</script>
